export default [
    "Current or former Tiber Creek employee",
    "Current or former Tiber Creek client",
    "Tiber Creek recruiter",
    "Posting on a job board",
    "Other"
];
